import { z } from 'zod';
import { IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * T10C-001 — Help article entity (Phase 10C help surface).
 *
 * A role-gated knowledge-base article surfaced at `/help` in the CRM. Read
 * paths only for V1 (Kenny edits content via seed SQL / a future admin tool —
 * there is no in-app authoring surface in Phase 10C).
 *
 * # Audience
 *
 * `audience` is the server-enforced role gate for content visibility:
 *   - `all`   → every staff role sees it.
 *   - `rep`   → reps + admins see it (admins see everything reps see).
 *   - `admin` → ONLY admin roles (superAdmin / opsAdmin) see it; non-admin
 *               reps NEVER receive an `admin`-audience article from the API.
 * The filter is applied in the route layer against the caller's resolved
 * roles (see routes/help.ts) — not client-side.
 *
 * The Drizzle table (db/schema/help-article.ts) is the structural twin; the
 * zod-drizzle-drift guard pairs the two. Every persisted column has a matching
 * field here (and vice-versa); there are no response-only synthetic fields.
 */
export const HelpArticleAudienceSchema = z.enum(['rep', 'admin', 'all']);
export const HelpArticleSchema = z.object({
    id: z.string(),
    type: z.literal('help_article'),
    schemaVersion: SchemaVersionSchema,
    slug: z.string(),
    title: z.string(),
    bodyMarkdown: z.string(),
    category: z.string(),
    audience: HelpArticleAudienceSchema,
    order: z.number().int(),
    published: z.boolean(),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=help-article.js.map